module.exports = __webpack_public_path__ + "static/media/key-org-pink.51bfb1d6.svg";